"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Title = exports.Slots = exports.Slot = exports.Container = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _widths = require("../../../styles/widths");

var _palette = require("../../../styles/palette");

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

var Container = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  max-width : ", "px;\n  max-height: ", "px;\n  margin-top: ", "px;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  overflow-y: auto;\n  overflow-x: hidden;\n"])), _widths.widths.base * 57, _widths.widths.base * 36, _widths.widths.base * 3);

exports.Container = Container;
Container.displayName = 'Container';

var Slot = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  color: ", ";\n  background: ", ";\n  border: ", ";\n  font-size: 14px;\n  font-weight: ", ";\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  justify-content: center;\n  border-radius: 1000px;\n  height: 32px;\n  min-width: 105px;  \n  box-sizing: border-box;\n  padding: 5px;\n  position: relative;\n  &::after {\n    content: '';\n    display: ", ";\n    position: absolute;\n    top: 50%;\n    left: 0;\n    width: 100%;\n    height: 1px;\n    border-bottom: solid 1px ", ";\n  }\n  &:focus {\n    outline: none;\n  }\n  &:hover {\n    cursor: pointer;\n  }\n"])), function (props) {
  return props.active ? _palette.palette.white : props.disabled ? _palette.palette.darkWhite : _palette.palette.bobBlack;
}, function (props) {
  return props.active ? _palette.palette.primary : props.disabled ? 'transparent' : _palette.palette.darkWhite;
}, function (props) {
  return props.disabled ? "solid 1px ".concat(_palette.palette.darkWhite) : 'none';
}, _widths.font.semi, function (props) {
  return props.disabled ? 'block' : 'none';
}, _palette.palette.darkWhite);

exports.Slot = Slot;
Slot.displayName = 'Slot';

var Slots = _styledComponents["default"].div(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  margin-top: 8px;\n  display: grid;\n  grid-column-gap: 16px;\n  grid-row-gap: 16px;\n  grid-template-columns: ", ";\n"])), function (props) {
  return props.length > 2 ? 'repeat(3, 1fr)' : 'repeat(2, 1fr)';
});

exports.Slots = Slots;
Slot.displayName = 'Slot';

var Title = _styledComponents["default"].div(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  font-size: 12px;\n  color: ", ";\n  margin-bottom: 3px;\n  width: 100%;\n"])), _palette.palette.bobBlack);

exports.Title = Title;
Title.displayName = 'Title';